var _linearGradient, _path, _radialGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _path13, _linearGradient13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH23(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 612 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 396,
    x2: 396,
    y2: 456,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1F000A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#300454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066AB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M-178 0h792v456h-792z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 270.3,
    cy: 131.1,
    r: 55.5,
    gradientTransform: "translate(-123 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F1F7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3ACB1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M131 156c-2-10 0-18 2-24l6-15c-27 5-47 29-47 55 0 31 25 56 56 56s55-25 55-56c-6 4-19 12-36 11-7 0-18-1-27-9-6-6-8-14-9-18z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 217.2,
    x2: 217.2,
    y1: 110.9,
    y2: 263,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-101 253c-17-4-28-20-24-37 3-17 20-28 37-25a21 21 0 0 1 41-9c0-3-3-18 7-33 9-14 24-18 27-19 2-10 10-18 20-19 11-1 22 7 24 19 17-6 35-1 45 12 9 11 10 26 5 40 7-11 19-17 32-15s23 13 25 26c0 0 14-8 27 0 9 5 14 16 13 27 5-7 13-9 19-6s8 12 6 19c-7 25-83 28-83 28s-49 2-99 2c-48 0-72-3-82-4a590 590 0 0 1-40-6z",
    opacity: 0.7
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 663.6,
    x2: 663.6,
    y1: 29.9,
    y2: 106,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M394 101c-11-2-18-10-16-18 2-9 13-15 25-13-1-5 4-10 11-11 6-2 13 1 16 7-1-2-2-10 4-17s15-9 17-9c2-6 7-9 13-10 8 0 15 4 16 10 11-3 23-1 29 6 6 5 7 13 4 19 4-5 12-8 21-7 8 1 15 6 16 13 0 0 9-4 18 0 6 3 9 8 8 14 3-4 9-5 12-3 4 1 6 6 5 9-5 13-55 14-55 14l-64 1a642 642 0 0 1-80-5z",
    opacity: 0.8
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -2904.7,
    x2: -2904.7,
    y1: 55.9,
    y2: 122,
    gradientTransform: "matrix(-1.1403 0 0 1 -2934 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M440 118c8-2 13-9 11-16-1-8-9-13-16-11 0-5-3-9-8-10s-9 1-11 6c0-2 2-8-3-15-4-6-10-7-12-8-1-4-4-8-9-8-5-1-10 3-11 8-7-2-15 0-19 5s-5 12-3 18c-3-5-8-8-14-7s-10 6-11 12c0-1-6-4-12 0-4 2-7 7-6 11-2-3-6-4-8-2-3 1-4 5-3 8 3 11 37 12 37 12a992 992 0 0 0 81-1l17-2z",
    opacity: 0.9
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 248.5,
    x2: 248.5,
    y1: 327.6,
    y2: 383.6,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M5 380c-7-2-12-8-11-14 2-6 9-10 17-9 0-4 3-8 8-9 5 0 10 2 12 6-1-1-2-7 3-13 4-5 11-6 12-7 1-3 5-6 9-7 6 0 11 3 12 7 7-2 16 0 20 5 4 4 5 9 3 14 3-4 9-6 15-5s10 5 11 10c0 0 7-3 13 0 4 2 6 6 6 10 2-3 6-4 8-3 3 1 4 5 3 7-3 10-38 11-38 11H62a390 390 0 0 1-57-3z",
    opacity: 0.8
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 77,
    x2: 77,
    y1: 299.9,
    y2: 356,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M-166 352c-8-1-13-7-11-13 1-7 9-11 17-10-1-4 3-7 8-8s10 1 11 5c0-1-1-7 3-12 5-5 11-7 13-7 1-4 4-7 9-7 5-1 10 2 11 7 8-2 16 0 21 4 4 4 5 10 2 15 3-4 9-6 15-6 6 1 11 5 12 10 0 0 6-3 12 0 4 2 7 6 6 10 2-3 6-3 9-2s4 4 3 7c-3 9-39 10-39 10l-46 1c-22 0-33-1-38-2l-18-2z",
    opacity: 0.8
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 598.5,
    x2: 598.5,
    y1: 289,
    y2: 345,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M355 341c-7-1-12-7-11-13 2-7 9-11 17-10 0-4 3-7 8-8s10 1 12 5c-1-1-2-7 3-12 4-5 11-7 12-7 1-4 5-7 9-7 6-1 11 2 12 7 7-2 16 0 20 4s5 10 3 15c3-4 9-6 15-6 6 1 10 5 11 10 0 0 7-3 13 0 4 2 6 6 6 10 2-3 6-3 8-2 3 1 4 4 3 7-3 9-38 10-38 10l-46 1a390 390 0 0 1-57-4z",
    opacity: 0.8
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 532.9,
    x2: 532.9,
    y1: 293.3,
    y2: 369.4,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4787A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1753"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M259 364c-12-2-19-10-17-18s14-14 26-13c-1-5 4-10 11-11 8-1 15 2 17 7 0-2-2-9 5-17 6-7 16-9 18-9 1-5 7-9 14-10 8 0 15 4 17 10 11-3 23-1 30 6 6 5 7 13 3 20 5-6 14-9 22-8 9 2 16 7 17 14 1-1 10-4 19 0 6 2 10 8 9 13 3-3 9-4 13-3 4 2 6 6 4 9-5 13-57 14-57 14a705 705 0 0 1-151-4z",
    opacity: 0.8
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -2980.2,
    x2: -2980.2,
    y1: 288,
    y2: 488.4,
    gradientTransform: "matrix(-1 0 0 1 -2762 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#412267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160B45"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m614 380-11-13c0 1 1 12-5 20-5 7-12 6-13 6-2 0-15 1-24-12-4-5-5-10-6-14l-17 13a370 370 0 0 0-104-92c-5 13-18 42-45 63a91 91 0 0 1-59 20c-4-1-10-4-15-11l-5-10c-8 13-22 31-42 45-24 18-76 28-82 21-9-10-9-25-9-26l-24 30a251 251 0 0 0-96-66c-12 13-48 49-91 56-20 3-43 10-53-7-8-14-5-35-3-45a372 372 0 0 0-66 62c-6-2-22-13-22-13v81l792-4"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 396,
    x2: 396,
    y1: 327,
    y2: 467,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#372871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190020"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m-178 392 12-10c0 1-1 9 5 14 5 5 12 4 13 4 2 0 14 1 23-8 3-3 5-7 6-10l16 9A315 315 0 0 1-2 327a113 113 0 0 0 102 58 30 30 0 0 0 19-15c8 9 21 22 41 32 23 12 74 19 80 14 8-7 8-17 8-18l24 21a242 242 0 0 1 93-46c11 9 47 34 89 39 19 2 41 7 51-5 8-10 5-24 3-31a347 347 0 0 1 64 43c6-1 13-4 21-9l21-10v67l-792-3"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 396,
    x2: 396,
    y1: 392.9,
    y2: 555.4,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#31083B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#180424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#161127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#15182A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#131C2B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M-178 418c20-9 44-17 72-22 80-13 135 14 225 36 42 10 100 16 216 27 123 12 279 21 279 21v38s-779 34-792 38V418z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 396.3,
    x2: 396.3,
    y1: 445.9,
    y2: 578.6,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#31083B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#180424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#161127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#15182A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#131C2B"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M-178 453c70 21 192 53 334 24l37-9c132-31 421-20 421-20v95S77 648-176 500c-2-33-1-3-1-40l-1-6z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 396.5,
    x2: 396.5,
    y1: 500.7,
    y2: 612,
    gradientTransform: "translate(-178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#31083B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#220028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1A0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#180424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#161127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#15182A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#131C2B"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M614 501a3309 3309 0 0 1-791 0v111h791z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH23);
export default __webpack_public_path__ + "static/media/h23.bab01727f1544590006a2a5d92478ceb.svg";
export { ForwardRef as ReactComponent };